let productSort = [
    {
        "id": 1,
        "title": "WMNS Cable Short-sleeve Knit IVORY",
        "imgUrl": "img/s1.jpg",
        "price": 98000
    },
    {
        "id": 2,
        "title": "WMNS V-neck Vest 1857 IVORY",
        "imgUrl": "img/s2.jpg",
        "price": 98000
    },
    {
        "id": 3,
        "title": "WMNS V-neck Sweater 1858 BLACK",
        "imgUrl": "img/s3.jpg",
        "price": 108000
    },
    {
        "id": 4,
        "title": "Basic knitted cardigan 1850 GREY",
        "imgUrl": "img/s4.jpg",
        "price": 128000
    },
    {
        "id": 5,
        "title": "Kangol Jacquard Pullover 1840 IVORY",
        "imgUrl": "img/s5.jpg",
        "price": 89600
    },
    {
        "id": 6,
        "title": "EDEW Knitted Vest 6102 LT.BLUE",
        "imgUrl": "img/s6.jpg",
        "price": 68600
    },
    {
        "id": 7,
        "title": "WMNS Marine Knit 1861 MINT",
        "imgUrl": "img/s7.jpg",
        "price": 98000
    },
    {
        "id": 8,
        "title": "WMNS Summer Cardigan 1860 IVORY",
        "imgUrl": "img/s8.jpg",
        "price": 128000
    }
]


export default productSort;